angular.module('zc.projects')

.directive 'zcThumbnailSelector', (ProjectThumbnailSelector, Meta, BaseProjectCrudEditor) ->

  class ThumbnailSelector extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality

  editor = new ThumbnailSelector(
    ProjectThumbnailSelector
    Meta
    '/templates/projects.settings/other/thumbnail_selector.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/other/thumbnail_selector.directive.coffee